/* import __COLOCATED_TEMPLATE__ from './no-search-results.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();